import * as types from './constants';

export default {

    [types.SET_PARAMS_SEARCH](state, data) {
        state.paramSearch = data;
    },
    [types.SET_QUESTION_WORK](state, data) {
        state.question = data;
    },
    [types.SET_PRAM_EXAM](state, data) {
        state.paramExam = data;
    },
    [types.SET_BOOKID](state, data) {
        state.bookId = data;
    },
    [types.SET_QUESTION](state, data) {
        state.questionIdSelect = data;
    },
    [types.SET_SLIDES_MAIN](state, data) {
        state.slidesMain = data;
    },

    [types.SET_SLIDES_IMG_MAIN](state, data) {
        state.slidesMainImg = data;
    },

    [types.SET_SLIDES_IMG_MAIN](state, data) {
        state.objActivitySlide = data;
    },

    [types.SET_SLIDE_CURR](state, data) {
        state.slideCurr = data;
    },

    [types.SET_INDEX_SLIDE_VISIBLE](state, data) {
        state.slideIndexVisible = data;
    },

    [types.SET_CLASSES](state, data) {
        state.classes = data;
    },

    [types.SET_DATA_MEDIA_VIEWER](state, data) {
        state.mediaPreviewData = data;
    },

    [types.SET_PREVIEW_MEDIA_VISIBLE_INDEX](state, data) {
        state.indexPreviewMedia = data;
    },

    [types.SET_LINK_VIDEO_AUDIO](state, data) {
        state.linkVideoAudio = data;
    },

    [types.SET_SLIDESHOW_VISIBLE](state, data) {
        state.isOpenSlideshow = data;
    },

    [types.SET_PARAM_FILTER_MEDIA_LIST](state, data) {
        state.paramsSearchMediaDetail = data;
    },

    [types.SET_SCALE_SLIDE](state, data) {
        state.scaleSlide = data;
    },
    [types.SET_TYPE_QUESTION](state, data) {
        state.typeQuestion = data;
    },
    [types.SET_VISIBLE_MODAL_FILE_UPLOADED](state, data) {
        state.isOpenModalFileUploaded = data;
    },
    [types.SET_KEY_SIDEBAR_VISIBLE](state, data) {
        state.keySidebarActive = data;
    },

    [types.SET_EXAM_INFO](state, data) {
        state.examInfo = data;
    },
    
    [types.SET_QUESTION_LIST](state, data) {
        state.questionList = data;
    },
    [types.SET_QUESTION_DETAIL](state, data) {
        state.questionDetail = data;
    },

    [types.SET_INDEX_QUESTION_WORKING](state, data) {
        state.indexQuestionWorking = data;
    },
    [types.SET_CLASSES_EXAM](state, data) {
        state.classesExam = data;
    },
    [types.SET_SUBJECTS_EXAM](state, data) {
        state.subjectsExam = data;
    },

    [types.SET_PARAMS_GET_DATA_QUESTION_SAMPLE](state, data) {
        state.paramsGetQuestionsSample = data;
    },

    [types.SET_BOOKID_FILTER_QUESTION_SAMPLE](state, data) {
        state.bookIdQuestions = data;
    },

    [types.SET_BOOKINDEXID_FILTER_QUESTION_SAMPLE](state, data) {
        state.bookIndexIdQuestions = data;
    },

    [types.SET_QUESTIONS_SAMPLE](state, data) {
        state.questionsSample = data;
    },

    [types.SET_QUESTION_CHOOSED](state, data) {
        state.questionsChoose = data;
    },

    [types.SET_QUESTION_ID_CHOOSED](state, data) {
        state.questionsIdChoose = data;
    },

    [types.SET_CHAPTER_ID_QUESTIONS](state, data) {
        state.chapterIdQuestion = data;
    },

    [types.SET_PARAMS_SEARCH_QUESTION_CHAPTER](state, data) {
        state.paramFilterQuestionsByChapter = data;
    },
    [types.SET_PARAMS_SEARCH_QUESTION_EXAM](state, data) {
        state.paramFilterQuestionsByExam = data;
    }
};
